import React, { useState } from 'react';
import api from '../services/api';

export default function OrcParam() {
  const [form, setForm] = useState({
    ANO: '',
    DTINICIO: '',
    DTFIM: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ANO: form.ANO,
        DTINICIO: new Date(form.DTINICIO).toISOString(),
        DTFIM: new Date(form.DTFIM).toISOString(),
        RECCREATEDBY: 'admin',
        RECCREATEDON: new Date().toISOString(),
      };

      await api.post('/api/man_orc_param', payload);
      alert('✅ Dados gravados com sucesso!');
    } catch (err) {
      console.error('❌ Erro ao gravar:', err);
      alert('Erro ao gravar os dados. Verifique os campos.');
    }
  };

  return (
    <div>
      <h2>Cadastro de Parâmetro</h2>
      <form onSubmit={handleSubmit}>
        <input
          name="ANO"
          placeholder="Ano"
          value={form.ANO}
          onChange={handleChange}
          required
        />
        <input
          name="DTINICIO"
          type="date"
          placeholder="Data Início"
          value={form.DTINICIO}
          onChange={handleChange}
          required
        />
        <input
          name="DTFIM"
          type="date"
          placeholder="Data Fim"
          value={form.DTFIM}
          onChange={handleChange}
          required
        />
        <button type="submit">Gravar</button>
      </form>
    </div>
  );
}
